import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

/** A canvas's package name: trimmed, non-empty. */
export const PackageName = pipe(
	string,
	parse((s) => {
		const name = s.trim();
		return name.length > 0 && name.length <= 200
			? success(name)
			: failure(s, 'Package name must be 1 to 200 characters');
	})
);
